import React, { Component } from 'react';
// import 'antd/dist/antd.css';
import { AutoComplete } from 'antd';

import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
// import { colourOptions } from '../data';
const colourOptions1 = [
  { value: 'Red', label: 'Red' },
  { value: 'Blue', label: 'Blue' },
  { value: 'Green', label: 'Green' },
  { value: 'Black', label: 'Black' },
  { value: 'Orange', label: 'Orange' },
  { value: 'Red', label: 'Red' }
];

const colourOptions=[{ "label": "Chicken 1000g", "value": 1 }, { "label": "Chicken 800g", "value": 2 }, { "label": "Chicken 900g", "value": 3 }, { "label": "Chicken 1200g", "value": 4 }, { "label": "Chicken 1100g", "value": 5 }, { "label": "Chicken 750g", "value": 6 }, { "label": "Oil", "value": 7 }, { "label": "Frying Crispies", "value": 8 }]
// const filterColors = (inputValue) =>
//   colourOptions.filter(i =>
//     i.label.toLowerCase().includes(inputValue.toLowerCase())
//   );


const filterVariants = (response) =>{
  return _.map(response.variants, function (res) { return { "label": res.name, "value": res.id } });
}

const promiseOptions = inputValue =>
  new Promise(resolve => {

    $.ajax({
      url: Spree.routes.variants_api + "?direct_query=true",
      quietMillis: 200,
      datatype: "json",
      type: 'GET',
      data: {
        q: {
          product_name_or_sku_cont: inputValue
        },
        token: Spree.api_key
      },
      headers: { "X-Spree-Token": Spree.api_key },
      success: function (response) {
        var result = _.map(response.variants, function (res) { return { "label": `${res.name} ${res.options_text}`, "value": res.id } })
        console.log(`search returned`)
        console.log( result) 

        resolve(response);

        // resolve(filterVariants(response));
      }
    });

  });

const throttledPromiseOptions = _.throttle(promiseOptions, 500)

const setModelId = (model) => {
  let activeSelect = $(`div.rs-parent:contains('${model.label}')`) 
  $(activeSelect).closest('.rs-parent').find('.variant-id').val(model.value)

}
const defaultOption = { label: 'Am your average default', value: 'newProduct.id' }
 
export default class ReactSelectProduct extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isLoading: false,
      options: {},
      value: props.defaultOption,
    };
  }
  createProduct = inputValue => {

    this.setState({ isLoading: true });
    const { options } = this.state;
    const $this = this
    $.ajax({
      type: "POST",
      dataType: 'json',
      url: Spree.routes.products_api,
      data: {
        "product[name]": inputValue, "product[price]": 0.00, token: Spree.api_key },
      success: function (newProduct) {
        console.log(`new option ${newProduct.name} created.`)

        let newOption = { label: newProduct.name, value: newProduct.id }

        $this.setState({
          isLoading: false,
          options: [...options, newOption],
          value: newOption,
        });
        setModelId(newOption)
      }
    });

  }
  
  handleChange = (newValue, actionMeta) => {
    // console.group('Value Changed');
    // console.log(newValue);
    // console.log(`action: ${actionMeta.action}`);
    // console.groupEnd();
    setModelId(newValue)
    this.setState({ value: newValue });
  };
  render() {
    const dataSource = ['12345', '23456', '34567'];

    return (
      <AsyncCreatableSelect
        cacheOptions
        defaultOptions
        isDisabled={this.state.isLoading}
        isLoading={this.state.isLoading}
        onChange={this.handleChange}
        value={this.state.value}
        loadOptions={throttledPromiseOptions}
        onCreateOption = {this.createProduct}
        createOptionPosition = "first"
        isValidNewOption={(inputValue, selectValue, selectOptions) => {
          const isNotDuplicated = !selectOptions
            .map(option => option.label)
            .includes(inputValue);
          const isNotEmpty = inputValue !== '';
          return isNotEmpty && isNotDuplicated;
        }}
      />
    );
  }
}